(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artistic-image-fade"] && !Shopify.designMode) return;
  try {
    
  class ArtisticImageFade {
    constructor(container) {
      this.container = container;
      this.sectionId = container.dataset.sectionId;
      this.enableScrollEffect = container.dataset.enableScrollEffect === 'true';
      this.checkbox = document.getElementById(`image-toggle-${this.sectionId}`);

      if (!this.checkbox) {
        console.error('Artistic Image Fade: Checkbox not found!');
        return;
      }

      if (this.enableScrollEffect) {
        this.initObserver();
      }
    }

    initObserver() {
      const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5, // Trigger when 50% of the element is visible
      };

      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Wait for 1 second before switching the toggle
            setTimeout(() => {
              this.checkbox.checked = true;
            }, 200); // 1000ms = 1 second

            // Stop observing after triggering to prevent re-triggering
            observer.unobserve(this.container);
          }
        });
      }, observerOptions);

      observer.observe(this.container);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.artistic-image-fade-section').forEach(section => {
      new ArtisticImageFade(section);
    });
  });

  // Handle Shopify theme editor updates
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.artistic-image-fade-section');
    if (section) {
      new ArtisticImageFade(section);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
